import * as React from "react";
import { graphql } from "gatsby";
import { Layout } from "../components/Layout";
import { SliceZone } from "../components/SliceZone";
import { PropTypes } from "prop-types";
import { filterHtml } from "../utils/filterHtml";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";

const Privacy = ({ data }) => {
  if (!data) return null;

  const page = data.prismicPrivacy || {};
  const { lang, type, url } = page || {};
  const title = page.data.title.text;
  const desc = page.data.meta_description;
  const alternateLanguages = page.alternate_languages || [];
  const activeDoc = {
    lang,
    type,
    url,
    alternateLanguages,
    title,
    desc,
  };

  return (
    <Layout activeDocMeta={activeDoc}>
      <div className="o-wrapper">
        <h1 className="c-intro-block__title">{page.data.title.text}</h1>
        <div
          className="o-intro-text"
          dangerouslySetInnerHTML={{ __html: filterHtml(page.data.intro.html) }}
        />
        <div className="c-divider u-mb0" />
      </div>

      <div className="o-wrapper">
        <div className="o-1-col">
          <SliceZone slices={page.data.body} />
        </div>
      </div>
    </Layout>
  );
};

Privacy.propTypes = {
  data: PropTypes.object,
};

export default withPrismicPreview(Privacy);

export const query = graphql`
  query MyPrivacyQuery($lang: String, $id: String, $locale: String) {
    locales: allLocale(filter: { language: { eq: $locale } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }

    prismicPrivacy(id: { eq: $id }, lang: { eq: $lang }) {
      _previewable
      data {
        body {
          ... on PrismicPrivacyDataBodyImage {
            id
            primary {
              image {
                url
                alt
                gatsbyImageData(
                  width: 1716
                  layout: CONSTRAINED
                  placeholder: NONE
                )
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 1716
                      layout: CONSTRAINED
                      placeholder: NONE
                    )
                  }
                  publicURL
                }
                thumbnails {
                  mobile {
                    url
                    gatsbyImageData(
                      width: 1230
                      layout: CONSTRAINED
                      placeholder: NONE
                    )
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          width: 1230
                          layout: CONSTRAINED
                          placeholder: NONE
                        )
                      }
                      publicURL
                    }
                  }
                }
              }
            }
            slice_type
          }
          ... on PrismicPrivacyDataBodyDownload {
            id
            slice_type
            primary {
              file {
                url
                size
                localFile {
                  extension
                  publicURL
                  size
                }
              }
              label
            }
          }
          ... on PrismicPrivacyDataBodyTextblock {
            id
            primary {
              text {
                html
              }
              title1 {
                text
              }
            }
            slice_type
          }
        }
        meta_description
        intro {
          html
        }
        title {
          text
        }
      }
      type
      url
      alternate_languages {
        document {
          ... on PrismicPrivacy {
            url
          }
        }
        lang
      }
      lang
    }
  }
`;
